import axios from 'axios';
// import config from "./config";
import message from './remind';
// import cookie from '@/network/cookie';
import remind from '@/network/remind';

const baseUrl = config.baseUrl;

import router from '../router/index'
import { clearAuthState, getLoginPathByPath } from '@/common/auth';

//请求超时时间
axios.defaults.timeout = 600000;
// axios.defaults.withCredentials = true;
//请求验证拦截器
function isDownloadRequest(url) {
  return url.indexOf('downloadTestCaseForZip') > -1 ||
    url.indexOf('exportDRankScoreInfo') > -1 ||
    url.indexOf('DownloadAll') > -1 ||
    url.indexOf('DownloadSelect') > -1 ||
    /report\/teacher\/.*\.xlsx(?:\?|$)/.test(url) ||
    /BUAAOJ\/reviews\/.*\/grades\.xlsx(?:\?|$)/.test(url);
}

function isSilentPollingRequest(url) {
  return url.indexOf("BUAAOJ/ai/testcase/result") > -1 ||
    /standard-solution\/coverage\/\d+(?:\?|$)/.test(url);
}

function closeLoading(requestConfig, delay = 0) {
  const loadingInstance = requestConfig && requestConfig.loadingInstance;
  if (!loadingInstance || typeof loadingInstance.close !== 'function') {
    return;
  }

  const close = () => {
    loadingInstance.close();
    if (requestConfig.loadingInstance === loadingInstance) {
      requestConfig.loadingInstance = null;
    }
  };
  if (delay > 0) {
    setTimeout(close, delay);
  } else {
    close();
  }
}

axios.interceptors.request.use(config => {
  const requestUrl = config.url || "";
  config.loadingInstance = null;
  const isSilentPolling = requestUrl.indexOf("unReadRecordOnMessageBoard") > -1 ||
    requestUrl.indexOf("getUnreadMessageCount") > -1 ||
    requestUrl.indexOf("getStudentUnreadMessageCount") > -1 ||
    isSilentPollingRequest(requestUrl);
  const isTeacherMessageBoardRequest = requestUrl.indexOf("teacher/message-board") > -1;
  if (!config.skipGlobalLoading && !requestUrl.includes("sendMassageToGpt") && requestUrl.indexOf("BUAAOJ/ai/v2/answer") === -1 && requestUrl.indexOf("getResultBySubmitId") === -1 && !isSilentPolling && !isTeacherMessageBoardRequest && requestUrl.indexOf("aliyuncs") === -1) {
    config.loadingInstance = message.loading("加载中");
  }
  if (isDownloadRequest(requestUrl)) {
    //导出文件
    config.responseType = 'blob';
  }
  console.log(config);
  return config;
}, error => {
  return Promise.reject(error);
});

//返回数据拦截器
axios.interceptors.response.use((response) => {
  // loadingInstance.service(remind.loading()).close();
  closeLoading(response.config, 200);

  const responseUrl = response.config && response.config.url ? response.config.url : "";
  if (isDownloadRequest(responseUrl)) {
    //导出文件
    return Promise.resolve(response);
  }
  if (response.data) {
    if (response.data.status === 200) {
      return Promise.resolve(response);
    } else if (response.data.status === -203) {
      remind.message(response.data.info, "warning");
      const loginPath = getLoginPathByPath(window.location.pathname);
      clearAuthState();
      return router.replace(loginPath);
    } else {
      console.log('error' + response.data.status)
      return Promise.reject({
        status: response.data.status,
        message: response.data.info,
        data: response.data.data
      });
    }
  } else {
    return Promise.resolve(response);
  }
}, error => {
  closeLoading(error && error.config);
  const response = error.response;
  if (response && response.status === 401) {
    remind.message((response.data && response.data.info) || "登录状态已失效，请重新登录", "warning");
    const loginPath = getLoginPathByPath(window.location.pathname);
    clearAuthState();
    router.replace(loginPath);
  } else if (response && response.status === 403) {
    remind.message((response.data && response.data.info) || "权限不足，无法执行该操作", "warning");
  }
  return Promise.reject({
    status: response ? response.status : null,
    message: response && response.data ? response.data.info : error.message,
    data: response ? response.data : null,
    response: response
  });
});


//封装请求方法
function formatReq(type, url, data, options = {}) {
  let token = sessionStorage.getItem('token') || '';
  console.log(token)
  return new Promise((reslove, reject) => {
    const requestConfig = {
      method: type,
      url: `${baseUrl}${url}`,
      skipGlobalLoading: Boolean(options.skipGlobalLoading),
      headers: {
        'content-Type': 'application/json',
        'token': token,
        'Authorization': token,
        'imagevercodetoken': sessionStorage.getItem('imageVerCodeToken')
      }
    };
    if (String(type).toLowerCase() === 'get') {
      requestConfig.params = data || {};
    } else {
      requestConfig.data = JSON.stringify(data);
    }
    axios(requestConfig).then(res => {
      reslove(res);
    }).catch(err => {
      console.log(err);
      if (options.suppressErrorMessage || isSilentPollingRequest(url)) {
        // 由调用页面展示包含业务上下文的错误信息。
      } else if (err.status === -1) {
        remind.message(err.message, "warning");
      } else if (err.status === -201) {
        remind.message(err.message, "warning");
      } else if (err.status === -203) {

      } else if (err.status === 401 || err.status === 403) {
        // HTTP 认证/授权错误已由响应拦截器统一提示。
      } else {
        remind.message("网络异常，请稍后重试", "error");
      }
      reject(err);
    });
  })
}

const querystring = require("querystring");

////封装请求方法----修改密码的type不同
function othertype(type, url, data) {
  let token = sessionStorage.getItem('token') || '';
  return new Promise((reslove, reject) => {
    axios({
      method: type,
      url: `${baseUrl}${url}`,
      headers: {
        'content-Type': 'application/x-www-form-urlencoded',
        'token': token,
        'Authorization': token,
        'imagevercodetoken': sessionStorage.getItem('imagevercodetoken')
      },
      data: querystring.stringify(data)
    }).then(res => {
      reslove(res);
    }).catch(err => {
      if (err.status === -1) {
        remind.message(err.message, "warning");
      }else if (err.status === -203) {

      } else if (err.status === 401 || err.status === 403) {
        // HTTP 认证/授权错误已由响应拦截器统一提示。
      } else {
        remind.message("网络异常，请稍后重试", "error");
      }
      reject(err);
    });
  })
}

//封装请求方法
function uploadReq(type, url, data) {
  let token = sessionStorage.getItem('token') || '';
  return new Promise((reslove, reject) => {
    axios({
      method: type,
      url: `${baseUrl}${url}`,
      headers: {
        'content-Type': 'multipart/form-data;boundary = ' + new Date().getTime(),
        'token': token,
        'Authorization': token,
        'imagevercodetoken': sessionStorage.getItem('imagevercodetoken')
      },
      data: data
    }).then(res => {
      reslove(res);
    }).catch(err => {
      if (err.status === -1) {
        remind.message(err.message, "warning");
      }else if (err.status === -203) {

      } else if (err.status === 401 || err.status === 403) {
        // HTTP 认证/授权错误已由响应拦截器统一提示。
      } else {
        remind.message("网络异常，请稍后重试", "error");
      }
    });
  })
}

const Http = {
  get: (url, params, options) => formatReq('get', url, params, options),
  post: (url, data, options) => formatReq('post', url, data, options),
  put: (url, data, options) => formatReq('put', url, data, options),
  patch: (url, data, options) => formatReq('patch', url, data, options),
  delete: (url, data, options) => formatReq('delete', url, data, options),
  otherpost: (url, data) => othertype('post', url, data),
  postfile: (url, data) => uploadReq('post', url, data),
  root: baseUrl
};

export default Http;



// WEBPACK FOOTER //
// ./src/network/index.js